import * as Api from '@util/api'
import { IOrganization } from '@util/api'
import Cookies from 'js-cookie'

export async function set(code: string): Promise<IOrganization | undefined> {
  const organizationData = await Api.getOrganization(Api.anonymousClient(), {
    code: code
  })
  if (organizationData.type === 'ok') {
    const data = organizationData.data
    Cookies.set(
      'organization',
      {
        name: data.name,
        subscription: data.subscription,
        type: data.type,
        code: data.code,
        coupon: data.coupon
      },
      { expires: 15 }
    )
    return data
  } else {
    return undefined
  }
}

export const get = (): IOrganization | null => {
  const organization = Cookies.getJSON('organization')

  return organization
}
